import { useTranslation } from 'react-i18next';

import { SelectMenu } from '@/components/molecules/SelectMenu';
import { AUDIT_IMPERSONATION, type AuditLogFilters } from '@/domain/auditLog';

interface ImpersonationSelectProps {
    filters: AuditLogFilters;
    onChange: (next: AuditLogFilters) => void;
    labelledBy: string;
}

const ANY = '';

/** Any, only or none: one choice of three, opened like the panel's other filter menus. */
export default function ImpersonationSelect(props: ImpersonationSelectProps) {
    const { filters, onChange, labelledBy } = props;
    const { t } = useTranslation();

    return (
        <SelectMenu
            value={filters.impersonation ?? ANY}
            onChange={(value) => {
                const next: AuditLogFilters = { ...filters };
                const chosen = AUDIT_IMPERSONATION.find((option) => option === value);
                if (chosen === undefined) delete next.impersonation;
                else next.impersonation = chosen;
                onChange(next);
            }}
            options={[
                { value: ANY, label: t('auditLog.filters.any') },
                ...AUDIT_IMPERSONATION.map((value) => ({
                    value,
                    label: t(`auditLog.chips.value.impersonation.${value}`),
                })),
            ]}
            variant="field"
            fullWidth
            aria-labelledby={labelledBy}
        />
    );
}
